import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = ["content"]

  connect() {
    console.log("Turbo Modal controller connected")
    this.modal = new Modal(this.element, {
      backdrop: 'static',
      keyboard: true,
      focus: true
    })
    this.show()
  }

  disconnect() {
    console.log("Turbo Modal controller disconnected")
    if (this.modal) {
      this.modal.dispose()
    }
  }

  show() {
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }

  // Handle successful form submissions
  submitEnd(event) {
    console.log("Form submission ended", event.detail)
    if (event.detail.success) {
      // Only hide modal on successful submissions (2xx responses)
      this.hide()
    }
  }

  // Clean up when modal is hidden
  cleanup() {
    console.log("Modal cleanup")
    // Remove the turbo frame content when modal is completely hidden
    const turboFrame = document.getElementById('modal')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }
}